import { FC, HTMLAttributes, useRef } from 'react';
import classNames from 'classnames';
import { useIntersectionObserver } from 'usehooks-ts/dist/esm/useIntersectionObserver';

export interface StickyProps extends HTMLAttributes<HTMLDivElement> {}

export const Sticky: FC<StickyProps> = ({ className, ...props }) => {
  const ref = useRef<HTMLDivElement>(null);
  const entry = useIntersectionObserver(ref, { threshold: [1] });

  return (
    <div
      ref={ref}
      className={classNames('sticky z-50 -top-1', className, {
        'is-stuck': entry?.intersectionRatio < 1
      })}
      {...props}
    />
  );
};
